import AdminCompanyRoutes from './AdminCompanyRoutes'

const AdminRoutes = [
    {
      path: "/admin",
      name: "Admin",
      component: () => import("@/pages/admin/AdminIndex.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'create', on: 'Company'
        }
      },
      children: [
        ...AdminCompanyRoutes
      ]
    },
  ]
  
  export default AdminRoutes